export const overlay = {
    width: "100%",
    height: "100%",
    pointerEvents: "none"
}

export const mask = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "300px",
    height: "494px",
    border: "2px solid #fff",
    borderRadius: "50%",
    overflow: "hidden",
    zIndex: 1
}

export const blackMask = {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.7)",
    zIndex: 0,
    pointerEvents: "none",
    mask: "radial-gradient(ellipse 174px 287px, transparent 149px, black 0)"
}
